import { cloneDeep } from 'lodash-es'
import type { StudentInfoChange } from 'src/interfaces/client/infoChanges'
import type { IFamily } from 'src/interfaces/family'

export const mergeFamilyPractitionersWithStudentDrafts = (
  family: IFamily,
  drafts: StudentInfoChange[] = [],
): IFamily => {
  const merged = cloneDeep(family)
  merged.medicalPractitioners ??= []

  for (const draft of drafts) {
    const practitioner = draft.changes.medicalPractitioner
    if (practitioner) {
      const index = merged.medicalPractitioners.findIndex(
        (candidate) => candidate.id === practitioner.id,
      )
      if (index >= 0) merged.medicalPractitioners[index] = cloneDeep(practitioner)
      else merged.medicalPractitioners.push(cloneDeep(practitioner))
    }
  }

  return merged
}
